import _ from "lodash";
import React from "react";
import styled from "styled-components";

import { COLOR_RED } from "@static/COLORS";

const ErrorValidateMessage = styled.span`
  color: ${COLOR_RED};
  font-size: ${"14px"};
  font-weight: 500;
  margin-left: 4px;
`;

const Container = styled.div`
  height: 18px;
  display: flex;
  justify-content: ${({ justify = "flex-end" }) => justify};
`;

export default ({ error, justify }) => {
  const message = _.get(error, ["message"]);
  return (
    <Container justify={justify}>
      {error && <ErrorValidateMessage>{message}</ErrorValidateMessage>}
    </Container>
  );
};
